module.exports = __webpack_public_path__ + "static/media/allfresh.00d9fa71.png";